import { useCallback, useContext } from 'react';
import { ChatActionType, type AccountSearchResult } from '@trinity/chat';
import { SubmitActionContext } from '../context';

export function useAccountSelectionAction(): (
  account: Pick<AccountSearchResult, 'id' | 'name'>
) => void {
  const submitAction = useContext(SubmitActionContext);

  return useCallback(
    (account: Pick<AccountSearchResult, 'id' | 'name'>) => {
      submitAction(
        {
          type: ChatActionType.SelectAccountSubject,
          payload: {
            accountId: account.id,
            accountName: account.name,
          },
        },
        `Use account ${account.name}.`
      );
    },
    [submitAction]
  );
}
